export default __webpack_public_path__ + "static/media/clear.3ed29439.mp4";